import { render, staticRenderFns } from "./InquiryBase.vue?vue&type=template&id=4c0e7a71&"
import script from "./InquiryBase.vue?vue&type=script&lang=js&"
export * from "./InquiryBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports